import { createContext, useContext, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const keyboardNavigationContext = /*#__PURE__*/createContext(false);
const TAB_KEY = 9;
const ARROW_LEFT_KEY = 37;
const ARROW_UP_KEY = 38;
const ARROW_RIGHT_KEY = 39;
const ARROW_DOWN_KEY = 40;
const codes = [TAB_KEY, ARROW_LEFT_KEY, ARROW_UP_KEY, ARROW_RIGHT_KEY, ARROW_DOWN_KEY];
function KeyboardNavigationProvider({
  children
}) {
  // eslint-disable-next-line no-use-before-define
  const isKeyboardNavigation = useIsKeyboardNavigation();
  return /*#__PURE__*/_jsx(keyboardNavigationContext.Provider, {
    value: isKeyboardNavigation,
    children: children
  });
}

/* Track whether user is interacting via keyboard.
   This is used to determine if we should show focus rings.
   Focus rings should only display on focus when isTabbing is true.
*/
function useIsKeyboardNavigation() {
  const [isKeyboardNavigation, setIsKeyboardNavigation] = useState(false);
  useEffect(function listenForMouseClicksAndKeydowns() {
    function handleClick() {
      setIsKeyboardNavigation(false);
    }
    function handleKeydown(e) {
      const isKeyboardEvent = codes.includes(e.keyCode);
      if (isKeyboardEvent) {
        setIsKeyboardNavigation(true);
      }
    }
    window.addEventListener('keydown', handleKeydown);
    window.addEventListener('mouseup', handleClick);
    return () => {
      window.removeEventListener('keydown', handleKeydown);
      window.removeEventListener('mouseup', handleClick);
    };
  }, []);
  return isKeyboardNavigation;
}
function useIsKeyboardNavigationState() {
  const context = useContext(keyboardNavigationContext);
  if (context === undefined) {
    throw new Error('useIsKeyboardNavigationState must be used within a KeyboardNavigationProvider');
  }
  return context;
}
export { KeyboardNavigationProvider, useIsKeyboardNavigationState };